import { render, staticRenderFns } from "./ItemDoResumo.vue?vue&type=template&id=30a18579&scoped=true&"
import script from "./ItemDoResumo.vue?vue&type=script&lang=ts&"
export * from "./ItemDoResumo.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDoResumo.vue?vue&type=style&index=0&id=30a18579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a18579",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle,VTooltip})
